import React from 'react'
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import cintillo from "../../assets/img/logo_menu_black.png";
import { ADMISION } from './Styles/StylesAdmision';

const ModalUserList = (props) => {
    const styles = StyleSheet.create(ADMISION[0]);

    let noName = (nombre) => {
        let nom = nombre;
        if (nombre === null || nombre === undefined) nom = "";
        return nom
    }

    let TipoUsu = (usu) => {
        switch (usu){
            case "EST":         return "Estudiante"
            case "PROF":        return "Profesor"
            case "DIR":         return "Directivo"
            case "ADMIN":       return "Administrativo"
            case "WEBMASTER":   return "Web Master"
        }
    }

    let fecha = (fecha) => {
        let diaActual = new Date(fecha);

        let day = diaActual.getDate();
        let month = diaActual.getMonth() + 1;
        let year = diaActual.getFullYear();
        if(day < 10) day = '0' + day;
        if(month < 10) month = '0' + month;

        return  day + '/' + month + '/' + year;
    }

    let estudiants = () => {
        if (props.data.length === 0) return (
            <View style={[styles.row]}>
                <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen usuarios</Text>
            </View>
        )
        
        let i = 0;
        return (
            props.data.map(option => {
                i++;
                if (i >= props.ini && i <= props.max){
                    if (option.ci !== null){
                        return(
                            <View key={option.id} style={[styles.row]}>
                                <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{i}</Text>
                                <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop]}>{`${option.nacionalidad}${option.ci}`}</Text>
                                <View style={[styles.colTablaInsc8, styles.bordeCol9, styles.borderTop]}>
                                    <Text style ={[styles.font8]}>
                                        {`${option.nombre_1} ${noName(option.nombre_2)} ${option.apellido_1} ${noName(option.apellido_2)} - [${TipoUsu(option.t_name)}]`}
                                    </Text>
                                    <Text style ={[styles.font8, {color: "#b41806"}]}>
                                        {option.email}
                                    </Text>
                                </View>
                                <Text style={[styles.colTablaRec1, styles.font9, styles.bordeCol9, styles.borderTop]}>{option.estado_name}</Text>
                                <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{fecha(option.f_nac)}</Text>
                            </View>
                        )
                    }else{
                        return(
                            <View key={option.id} style={[styles.row]}>
                                <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{i}</Text>
                                <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop]}>**********</Text>
                                <View style={[styles.colTablaInsc8, styles.bordeCol9, styles.borderTop]}>
                                    <Text style ={[styles.font8]}>
                                        ESTE USUARIO NO POSEE DATOS REGISTRADOS
                                    </Text>
                                    <Text style ={[styles.font8, {color: "#b41806"}]}>
                                        {option.email}
                                    </Text>
                                </View>
                                <Text style={[styles.colTablaRec1, styles.font9, styles.bordeCol9, styles.borderTop]}>**********</Text>
                                <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>**********</Text>
                            </View>
                        )
                    }
                }
            })
        )
    }
    
    return (
        <PDFViewer style={styles.section}>
            <Document title="Listados de Usuarios">
                <Page size="letter" style={styles.body}>
                    <View style={styles.row}>
                        <Image
                            style={[styles.colContent40, styles.logo]}
                            src={cintillo}
                        />
                        <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                            <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={[styles.bordeConstancia, {marginTop: 15, backgroundColor: "#FFF", padding: 4,}]}>
                            <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. LISTADO DE USUARIOS</Text>
                            <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                                <View style={[styles.row]}>
                                    <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                                    <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>CÉDULA</Text>
                                    <Text style={[styles.colTablaInsc8, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>USUARIO</Text>
                                    <Text style={[styles.colTablaRec1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>LUGAR DE NAC.</Text>
                                    <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>FECHA</Text>
                                </View>
                                {estudiants()}
                            </View>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={[styles.footer]}>
                            <View style={[styles.row]}>
                                <View style={[styles.col6]}>
                                <Text style={[styles.linea3]}></Text>
                                    <Text style={[styles.encabezado2]}>
                                        Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                        C.P.1061  Edo Miranda - Caracas - Venezuela
                                    </Text>
                                    <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                        Telefax: +58 212 9930983 | 9939139 | 9910710.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    )
}

export default ModalUserList;


// WEBPACK FOOTER //
// ./src/components/Reportes/ModalUserList.jsx